
import "./styles/App.css";
import axios from "axios";
import "./utils/apiInterceptor";
import { useNavigate } from "react-router-dom";
import { gapi } from 'gapi-script';
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import useSessionTimeout from "./hooks/useSessionTimeout"; 
import WelcomePage from "./components/Auth/WelcomePage";
import Login from "./components/Auth/Login";
import RegistrationForm from "./components/Auth/Register";
import ResetPasswordForm from "./components/Auth/ForgotPassword";
import HiringManagerDashboard from "./components/HiringManager/HiringManagerDashboard";
import JDDetails from "./components/shared/JDDetails";
import JobDescriptionForm from "./components/HiringManager/JobDescriptionForm";
import RecruiterDashboard from "./components/Recruiter/RecruiterDashboard";
import ResumeDisplay from "./components/Recruiter/ResumeDisplay";

import InterviewerDashboard from "./components/Interviewer/InterviewerDashboard";
import SchedulingPage from './components/Recruiter/SchedulingPage';
import FeedbackForm from './components/Interviewer/FeedBackForm';
import AdminDashboard from './components/Admin/AdminDashboard';
import ArchivedJdsPage from "./components/HiringManager/ArchivedJdsPage";
import CandidateProfiles from './components/shared/CandidateProfile';
import CandidateData from "./components/shared/CandidateData";
import RegistrationSuccess from "./components/Auth/RegisterSuccess";
import AlreadyRegistered from "./components/Auth/AlreadyRegistered";
import ScreeningTestDetails from "./components/shared/ScreeningTestDetails";
import PendingData from "./components/shared/PendingData";
import ProtectedRoute from "./ProtectedRoute";



import HRDashboard from "./components/HRPages/Hrdashboard";
import OnboardingPage from "./components/HRPages/CandidateBoardingPages/OnboardingPage";
import CandidateUploadPage from "./components/HRPages/BenchPeople/CandidateUploadPage";
import SeniorReviewPage    from "./components/HRPages/BenchPeople/SeniorReviewPage";

import BenchPeople from "./components/HRPages/BenchPeople/Benchpeople";
import BenchCandidateForm from "./components/HRPages/BenchPeople/BenchCandidateForm";
import Employees   from "./components/HRPages/EmployeePages/EmployeesPage";
import Reports    from "./components/HRPages/Reports";
import CandidateOfferPortal from "./components/HRPages/OfferReleasePages/Candidateofferportal";


import AcceptedCandidatesPage from "./components/HRPages/OfferReleasePages/Acceptedcandidatespage";
import AcceptedCandidateDetail from "./components/HRPages/OfferReleasePages/Acceptedcandidatedetail";
import OffboardingPage from "./components/HRPages/CandidateBoardingPages/Offboardingpage";
import ClientManagement from "./components/HiringManager/Clientmanagement";


import RbotManagerDashboard   from "./components/ManagerPages/RbotManagerDashboard";
import ManagerDashboard   from "./components/ManagerPages/ManagerDashboard";
import RecruiterReportsPage from "./components/ManagerPages/RecruiterReportsPage";
import AllClientsAnalytics from "./components/ManagerPages/ClientManagement/ClientAnalytics";
import Skills from "./components/Recruiter/Skills";
import CandidateBrowserPage from "./components/ManagerPages/CandidateManagement/Candidatebrowserpage";

 import ClientSummaryReport from "./components/Reports/ClientSummaryReport";
import ProctoringSessionsPage from "./components/Proctoring/ProctoringSessionsPage";
import ProctoringCandidatePage from "./components/Proctoring/ProctoringCandidatePage";
import MfaEnroll from "./components/Auth/MfaEnroll";

 axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        const status = error.response?.status;
        const message = error.response?.data?.message;
         const authMessages = [
            "Please login first to continue",
            "Session expired, please log in again",
            "Invalid token",
            "Token has expired",
            // model service (flask_jwt_extended loaders in app_config.py)
            "Authorization token is required",
            "Invalid authorization token",
            "Authorization token has expired",
            "Authorization token has been revoked",
        ];
        console.log(message)
        if (status === 401 && authMessages.includes(message)) {
            localStorage.removeItem("token");
            localStorage.removeItem("rbotUser");
            window.location.href = "/login";
        }
        return Promise.reject(error);
    }
);
function App() {
    return (
        <Router>
            <SessionTimeoutWrapper />
        </Router>
    );
}
function SessionTimeoutWrapper() {
    const navigate = useNavigate();

    const handleLogout = () => {
        alert("Session expired. Redirecting to login...");
        const email = localStorage.getItem("email");
        try {
            const tokens = JSON.parse(localStorage.getItem("userTokens")) || {};
            if (email && tokens[email]) {
                delete tokens[email];
                localStorage.setItem("userTokens", JSON.stringify(tokens));
            }
        } catch {
            localStorage.removeItem("userTokens");
        }
        localStorage.removeItem("rbotUser");
        localStorage.removeItem("token");
        localStorage.removeItem("email");
        sessionStorage.clear();
        navigate("/login", { replace: true });
    };

    useSessionTimeout(handleLogout);

    return (
        <Routes>
                    <Route path="/"                element={<WelcomePage />} />  
                    <Route path="/register" element={<RegistrationForm />} />
                    <Route path="/registerSuccess" element={<RegistrationSuccess />} />
                    <Route path="/alreadyregistered" element={<AlreadyRegistered />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/ResetPasswordForm" element={<ResetPasswordForm />} />

                    <Route path="/jd-resume-upload/:token" element={<CandidateUploadPage />} />
                    <Route path="/jd-resume-review/:token"  element={<SeniorReviewPage />} />
                    <Route path="/candidate-form/:token" element={<BenchCandidateForm />} /> 
                    <Route path="/offer/:token" element={<CandidateOfferPortal />} />




                    <Route element={<ProtectedRoute />}>
                        <Route path="/hiring-dashboard" element={<HiringManagerDashboard />}/>
                        <Route path="/JDDetails" element={<JDDetails />}/>
                        <Route path="/job-description-form" element={<JobDescriptionForm />}/>
                        <Route path="/recruiter-dashboard" element={<RecruiterDashboard />} />
                        <Route path="/interviewer-dashboard" element={<InterviewerDashboard />} />
                        <Route path="/resumedisplay" element={<ResumeDisplay />} />   
                        <Route path="/schedulingPage" element={<SchedulingPage />} />
                        <Route path="/feedback" element={<FeedbackForm />} />                  
                        <Route path="/admin-dashboard" element={<AdminDashboard />} />
                        <Route path="/ArchivedJdsPage" element={<ArchivedJdsPage />} />
                        <Route path="/CandidateProfiles/:jdId" element={<CandidateProfiles />} />
                        <Route path="/CandidateData/:candidateId" element={<CandidateData />} />  
                        <Route path="/screening/:screeningID" element={<ScreeningTestDetails />} />  
                        <Route path="/PendingData" element={<PendingData />} /> 
                        <Route path="/" element={<RecruiterDashboard />} />
                        <Route path="/dashboards" element={<RecruiterDashboard />} />

                        <Route path="/onboarding" element={<OnboardingPage />} />
                        <Route path="/hr-dashboard" element={<HRDashboard />}/>
                        <Route path="/bench" element={<BenchPeople />}/>
                        <Route path="/reports" element={<Reports/>}/>
                        <Route path="/accepted-candidates" element={<AcceptedCandidatesPage />} />
                        <Route path="/accepted-candidates/:candidateId" element={<AcceptedCandidateDetail />} />
                        <Route path="/OffboardingPage" element={<OffboardingPage />}/>

                        <Route path="/manager/recruiters" element={ <RecruiterReportsPage />}/>
                        <Route path="/manager/dashboard"  element={ <ManagerDashboard /> }/>

                        <Route path="/rbot-team-analytics"    element={<RbotManagerDashboard />} />
                        <Route path="/clients/analytics/all" element={<AllClientsAnalytics />} />
                        <Route path="/clients/analytics"     element={<AllClientsAnalytics />} />
                        <Route path="/clients"    element={<ClientManagement />} />
                        <Route path="/skills" element={ <Skills /> }/>
                        <Route path="/candidate-browser" element={<CandidateBrowserPage />} />
                       
                        <Route path="/reports/client-summary" element={<ClientSummaryReport />} />
                        <Route path="/proctoring" element={<ProctoringSessionsPage />} />
                        <Route path="/proctoring/:candidateId" element={<ProctoringCandidatePage />} />
                     </Route>

                    <Route path="*" element={<Navigate to="/" replace />} />
                    <Route path="/mfa-setup" element={<MfaEnroll />} />
         </Routes>
    );
}

gapi.load("client:auth2", ()=>{
    gapi.client.init({
      clientId:'320668170244-e1pjdbp6jpbutb6vppmr32tvna8t74ak.apps.googleusercontent.com',
      Plugin_name:"chat",
    });
 
});      
 
export default App;



